import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Iban } from "../../interfaces/Iban";

@Component({
  selector: "iban-dialog",
  templateUrl: "iban-dialog.html",
  standalone: false,
})
export class IbanDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<IbanDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Iban
  ) {}

  ngOnInit(): void {
    // Initialiser les valeurs vides si nécessaire
    this.data.pays = this.data.pays || "";
    this.data.banque = this.data.banque || "";
    this.data.guichet = this.data.guichet || "";
    this.data.compte = this.data.compte || "";
    this.data.cle = this.data.cle || "";
  }

  onFieldChange(fieldName: string, nextInput: HTMLInputElement | null): void {
    const value = this.data[fieldName];
    
    // Si on a atteint le maximum de caractères, passer au champ suivant
    const maxLengths = {
      pays: 4,
      banque: 5,
      guichet: 5,
      compte: 11,
      cle: 2
    };

    if (value && value.length >= maxLengths[fieldName] && nextInput) {
      setTimeout(() => {
        nextInput.focus();
      }, 10);
    }
  }

  onKeyDown(event: KeyboardEvent, prevInput: HTMLInputElement | null, nextInput: HTMLInputElement | null): void {
    const input = event.target as HTMLInputElement;
    
    // Si on appuie sur Backspace et que le champ est vide, revenir au champ précédent
    if (event.key === "Backspace" && input.value.length === 0 && prevInput) {
      event.preventDefault();
      prevInput.focus();
      prevInput.setSelectionRange(prevInput.value.length, prevInput.value.length);
    }
    
    // Si on appuie sur la flèche droite à la fin du champ, passer au suivant
    if (event.key === "ArrowRight" && input.selectionStart === input.value.length && nextInput) {
      event.preventDefault();
      nextInput.focus();
      nextInput.setSelectionRange(0, 0);
    }
    
    // Si on appuie sur la flèche gauche au début du champ, revenir au précédent
    if (event.key === "ArrowLeft" && input.selectionStart === 0 && prevInput) {
      event.preventDefault();
      prevInput.focus();
      prevInput.setSelectionRange(prevInput.value.length, prevInput.value.length);
    }
  }


  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.dialogRef.close(this.data);
  }
}
